import {
  ChangeDetectionStrategy, Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {FormControl} from "@angular/forms";
import {BuilderGeneratedPageSectionI} from "../../../../builder-v2.interface";

@Component({
    selector: 'db-page-section',
    templateUrl: './page-section.component.html',
    styleUrl: './page-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageSectionComponent implements OnInit {
  @Input() section: BuilderGeneratedPageSectionI;
  @Input() static: boolean;
  @Input() title: string;
  @Input() builderStep: boolean;
  @Input() selected: boolean;
  @Output() onAddSectionBelow: EventEmitter<void> = new EventEmitter<void>();
  @Output() isEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() inputChange: EventEmitter<{ section_title: string; section_description: string }> = new EventEmitter<{
    section_title: string;
    section_description: string
  }>();
  @Output() valueChange: EventEmitter<{ section_title: string; section_description: string }> = new EventEmitter<{
    section_title: string;
    section_description: string
  }>();
  @Input() titleControl: FormControl<string> = new FormControl<string>('');
  @Input() descriptionControl: FormControl<string> = new FormControl<string>('');


  constructor() {}

  ngOnInit() {
    // console.log(this.section);
  }

}
